

















































import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import UiModal from '@/components/ui/UiModal.vue'
import UiLabel from '@/components/ui/UiLabel.vue'
import UiInput from '@/components/ui/UiInput.vue'
import UiTextarea from '@/components/ui/UiTextarea.vue'
import UiButton from '@/components/ui/UiButton.vue'
import { storeModuleName } from '@/store/modules/ui'
import { AppealConsultation, Profile } from '@/requests/mainApi'
import { masks } from '@/utils/plugins/inputMask'
import { removePhoneMask } from '@/utils/helpers/helpFunctions'

interface Data {
  dataModel: AppealConsultation
  viewErrors: boolean
  timeToOpenPage: number
  modalSent: boolean
}

interface Methods {
  resetDataModel: () => void
  setConsultationModalStatus: (value: boolean) => void
  analyticsSend: () => void
  consultationRequest: (variables: AppealConsultation) => void
}

interface Computed {
  userData: Profile
  phoneErrorView: boolean
  nameErrorView: boolean
  emailErrorView: boolean
  questionErrorView: boolean
  validate: boolean
  refModal: any
}

interface Props {}

export default Vue.extend({
  name: 'UiConsultationModal',
  components: {
    UiModal,
    UiLabel,
    UiInput,
    UiTextarea,
    UiButton
  },
  data () {
    return {
      dataModel: {
        phone: '',
        name: '',
        email: '',
        promoCode: '',
        question: ''
      },
      viewErrors: false,
      timeToOpenPage: 0,
      modalSent: false,
      masks
    }
  },
  computed: {
    phoneErrorView () {
      return this.viewErrors && removePhoneMask(this.dataModel.phone!).length !== 11
    },
    nameErrorView () {
      return this.viewErrors && !this.dataModel.name
    },
    emailErrorView () {
      return this.viewErrors && !(/\S+@\S+\.\S+/.test(this.dataModel.email!))
    },
    questionErrorView () {
      return this.viewErrors && !this.dataModel.question
    },
    validate () {
      return !this.phoneErrorView && !this.nameErrorView &&
        !this.emailErrorView && !this.questionErrorView
    },
    refModal () {
      return (this.$refs as any).modal
    },
    ...mapGetters(storeModuleName, ['consultationModalStatus']),
    ...mapGetters(['userData'])
  },
  watch: {
    consultationModalStatus (val: boolean) {
      if (val) {
        this.dataModel.phone = this.userData.phone || ''
        this.dataModel.name = this.userData.firstName || ''
        this.dataModel.email = this.userData.email || ''
        this.refModal.open()
        this.timeToOpenPage = new Date().getTime()
      }
    }
  },
  methods: {
    onModalClose () {
      this.viewErrors = false
      this.setConsultationModalStatus(false)
      this.analyticsSend()
      this.modalSent = false
    },
    async sendRequest () {
      this.viewErrors = true
      if (!this.validate) return

      await this.consultationRequest(this.dataModel)
      this.modalSent = true
      this.refModal.close()

      this.resetDataModel()
    },
    analyticsSend () {
      this.$analytics.logEvent('get_consultation', {
        screen: this.$route.meta.analyticsName,
        time: Math.round((new Date().getTime() - this.timeToOpenPage) / 1000),
        data: (this.dataModel.question ? ('Question: ' + this.dataModel.question + '; ') : '') +
          (this.dataModel.promoCode ? ('Promo: ' + this.dataModel.promoCode) : ''),
        result: this.modalSent
      })
    },
    resetDataModel () {
      this.dataModel = {
        phone: '',
        name: '',
        email: '',
        promoCode: '',
        question: ''
      }
    },
    ...mapMutations(storeModuleName, ['setConsultationModalStatus']),
    ...mapActions(['consultationRequest'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
